/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Einvoice_Auto_Sent_Unsettled_TitleInputs */

const vi_pos_einvoice_auto_sent_unsettled_title = /** @type {(inputs: Pos_Einvoice_Auto_Sent_Unsettled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn đã gửi lên MISA nhưng chưa có kết quả cuối`)
};

/**

* @param {Pos_Einvoice_Auto_Sent_Unsettled_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_einvoice_auto_sent_unsettled_title = /** @type {((inputs?: Pos_Einvoice_Auto_Sent_Unsettled_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Einvoice_Auto_Sent_Unsettled_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_einvoice_auto_sent_unsettled_title(inputs)
});